function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 48" {...props}><path d="M65.58 21.318L67.7 0 46.055 1.797l5.725 4.894-24.327 24.288-11.352-11.334 5.656-5.31L0 12.8l1.735 21.462 6.257-6.521 19.461 19.43 32.436-32.384 5.691 6.531" /></svg>;
});